import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { NgxStripeModule } from 'ngx-stripe';
import { ButtonModule } from 'primeng/button';

import * as fromPayment from '@offconon/shared/data/stores/shared-data-access-payment';

import { StripeCardPayComponent } from './stripe-card-pay.component';
@NgModule({
  imports: [
    ButtonModule,

    NgxStripeModule.forRoot(),
    StoreModule.forFeature(fromPayment.PAYMENT_FEATURE_KEY, fromPayment.paymentReducer),
    StripeCardPayComponent,
    TranslateModule,
  ],
  exports: [StripeCardPayComponent],
})
export class StripeCardPayModule {}
